import type { FaireProductEntity } from "../../entity_types/product";

export const p_tvpzhyjtmm: FaireProductEntity = {
  token: "p_tvpzhyjtmm",
  type: "product",
  name: "Seashell Locket Necklace with Blue Resin & Silver Chain \u2013 Ocean-Inspired Jewelry Gift",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/ca719e206eca4ec6a090dac3681ec92ca3acb8e4d8bf277bb18fb819272388c8.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/38ff3805f7573b4c24d425482a1d43d688185eeba1639c606cbfb488e8296d1b.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
